import { config } from '../config';
import { authHeader } from '../helpers';
import axiosInstance from '../axiosInstance';

export const advisorService = {
  getCodes,
  addCode,
  removeCode,
  getProviders,
  getAdvisors,
  updateAdvisor,
  deleteAdvisor,
  addAdvisor,
  mappAdvisorCode,
  getClientById,
  getClientBalances,
  removeAdvisorCode,
  inviteAdvisor
};

function addAdvisor(data) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance.post(`${config.advisor}/advisors`, data, requestOptions).then((response) => {
    return response.data;
  });
}

function updateAdvisor(data) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance
    .put(`${config.advisor}/advisors/${data._id}`, data, requestOptions)
    .then((response) => {
      return response.data;
    });
}

function inviteAdvisor(id) {
  console.log('we are here with the data', id);

  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance
    .get(`${config.advisor}/advisors/invite/${id}`, requestOptions)
    .then((response) => {
      return response.data;
    });
}

function mappAdvisorCode(data) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance
    .put(`${config.advisor}/advisor/code/map/${data.id}`, data, requestOptions)
    .then((response) => {
      return response.data;
    });
}

function removeAdvisorCode(data) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance
    .put(`${config.advisor}/advisor/code/map/remove/${data.id}`, data, requestOptions)
    .then((response) => {
      return response.data;
    });
}

function deleteAdvisor(id) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance
    .delete(`${config.advisor}/advisors/${id}`, requestOptions)
    .then((response) => {
      return response.data;
    });
}

function getAdvisors() {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance.get(`${config.advisor}/advisors`, requestOptions).then((response) => {
    return response.data;
  });
}

function getCodes() {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance.get(`${config.advisor}/codes`, requestOptions).then((response) => {
    return response.data;
  });
}

function addCode(data) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance.post(`${config.advisor}/codes`, data, requestOptions).then((response) => {
    return response.data;
  });
}

function removeCode(code) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance
    .delete(`${config.advisor}/codes/${code}`, requestOptions)
    .then((response) => {
      return response.data;
    });
}

function getProviders() {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance.get(`${config.advisor}/providers`, requestOptions).then((response) => {
    return response.data;
  });
}

function getClientById(id) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance.get(`${config.advisor}/client/${id}`, requestOptions).then((responce) => {
    return responce.data;
  });
}

function getClientBalances(id) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance
    .get(`${config.advisor}/client/${id}/balances`, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}
